import { memo, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { LotDetailContext } from "../../../Contexts/LotDetailContext";
import DataTable from "../../../DataTable/datatable.component";
import DateColumn from '../../../DataTable/datatable.datecolumn';
import NoFilter from "../../../DataTable/datatable.nofilter";

const PackoutSection = memo(function PackoutSection() {
    const { t } = useTranslation();
    const {
        lotDetail:
        {
            packouts
        }
    } = useContext(LotDetailContext);

    const tableColumns = [
        {
            Header: t('LotDetails.Packouts.PackageNumber'),
            accessor: 'packageNumber'
        },
        {
            Header: t('LotDetails.Packouts.GrossWeight'),
            accessor: 'grossWeight',
            Filter: NoFilter
        },
        {
            Header: t('LotDetails.Packouts.TareWeight'),
            accessor: 'tareWeight',
            Filter: NoFilter
        },
        {
            Header: t('LotDetails.Packouts.NetWeight'),
            accessor: 'netWeight',
            Filter: NoFilter
        },
        {
            Header: t('LotDetails.Packouts.Seal'),
            accessor: 'seal'
        },
        DateColumn({ header: t('LotDetails.Packouts.PackoutStart'), accessor: 'packoutStartUtc' }),
        DateColumn({ header: t('LotDetails.Packouts.PackoutEnd'), accessor: 'packoutEndUtc' }),
        {
            Header: t('LotDetails.Packouts.Station'),
            accessor: 'station'
        }
    ];

    const initialState = {
        sortBy: [
            {
                id: 'packoutStartUtc',
                desc: false
            }
        ]
    };

    return packouts?.length > 0
        ? <DataTable tableColumns={tableColumns} tableData={packouts} initialState={initialState} />
        : <span>{t('CommonResponses.NoData')}</span>;
});

export default PackoutSection;